class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    console.log('🔄 onVariantChange called');
    this.updateOptions();
    console.log('✅ Options updated:', this.options);
    this.updateMasterId();
    console.log('✅ Current variant:', this.currentVariant);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    const variantData = this.getVariantData();
    console.log('🔍 All variants with full details:');
    variantData.forEach((v, i) => {
      console.log(`  ${i + 1}. [${v.options.join(' | ')}] - Available: ${v.available} - ID: ${v.id}`);
    });
    console.log('🎯 Looking for:', this.options);
    
    this.currentVariant = variantData.find((variant) => {
      const matches = !variant.options.map((option, index) => {
        const selected = this.options[index];
        const variantOption = option;
        const isMatch = selected === variantOption;
        
        if (!isMatch && selected && variantOption) {
          console.log(`  ❌ Mismatch: "${selected}" !== "${variantOption}"`);
        }
        
        return isMatch;
      }).includes(false);
      
      if (matches) {
        console.log('✨ Match found:', variant.options, 'ID:', variant.id);
      }
      
      return matches;
    });
    
    if (!this.currentVariant) {
      console.warn('⚠️ No variant found for:', this.options);
      console.warn('💡 Tip: Check if variant option names match exactly (case-sensitive, spaces, etc.)');
    }
  }

  updateMedia() {
    if (!this.currentVariant){
      this.updateSliderCounter();
      return;
    } 
    const currentMedia = document.querySelector(
      `.product__media-item.current-variant`
    );

    if(!this.currentVariant?.featured_media){
      const variantMedia = document.querySelectorAll(
        `.product__media-item.variant-image`
      );
      variantMedia.forEach((variant) => {
        variant.classList.add("hidden");
        variant.classList.remove("current-variant");
      })
      this.updateSliderCounter();
      return;
    }
    
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia){
      this.updateSliderCounter();
      return;
    } 

    newMedia.classList.add('current-variant');
    newMedia.classList.remove('hidden');

    if(currentMedia){
      currentMedia.classList.remove('current-variant');
      currentMedia.classList.add('hidden');
    }

    const parent = newMedia.parentElement;
    parent.classList.toggle('changed');
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });

    
    this.updateSliderCounter();

    
    
  }
  updateSliderCounter(){
    const visibleMedia = document.querySelectorAll(".product__media-item:not(.hidden)");
    const sliderCounter = document.querySelector(".slider-buttons");

    if(!sliderCounter) return
    
    if(visibleMedia.length == 1){
      sliderCounter.classList.add('hidden');
    }else{
      sliderCounter.classList.remove('hidden');
    }
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    console.log('📝 Updating variant input for forms:', productForms.length);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      console.log('  📌 Form:', productForm.id, '- Old value:', input?.value, '- New value:', this.currentVariant.id);
      if (input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        console.log('  ✅ Updated to:', input.value);
      } else {
        console.warn('  ⚠️ Input not found in form:', productForm.id);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    const galleryElement = document.getElementById(`gallery-${this.dataset.section}`);
    const priceElement = document.getElementById(`price-${this.dataset.section}`);
    
    if (galleryElement) galleryElement.classList.add('loading');
    if (priceElement) priceElement.classList.add('loading');

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        //const id = `price-${this.dataset.section}`;
        this.replaceInfo(`price-${this.dataset.section}`, responseText);
        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        this.replaceInfo(`gallery-${this.dataset.section}`, responseText);

      });
  }

  replaceInfo(id, responseText) {
    const html = new DOMParser().parseFromString(responseText, 'text/html')
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;

    if (destination) destination.classList.remove('loading');
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  
  connectedCallback() {
    // Aggiorna la disponibilità delle opzioni al caricamento
    this.updateOptions();
    this.updateOptionsAvailability();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    console.log('📋 Fieldsets found:', fieldsets.length);
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      console.log('  ✓ Checked value:', checkedRadio?.value);
      return checkedRadio.value;
    });
    
    // Aggiorna la disponibilità delle opzioni
    this.updateOptionsAvailability();
  }
  
  updateOptionsAvailability() {
    const variants = this.getVariantData();
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    
    fieldsets.forEach((fieldset, fieldsetIndex) => {
      const inputs = Array.from(fieldset.querySelectorAll('input'));
      
      inputs.forEach((input) => {
        const optionValue = input.value;
        
        // Crea un array di opzioni con questo valore nella posizione corrente
        const testOptions = [...this.options];
        testOptions[fieldsetIndex] = optionValue;
        
        // Verifica se esiste almeno una variante disponibile con questa combinazione
        const hasAvailableVariant = variants.some((variant) => {
          return testOptions.every((option, index) => {
            return variant.options[index] === option;
          }) && variant.available;
        });
        
        // Disabilita l'input se non ci sono varianti disponibili
        const label = input.nextElementSibling;
        if (!hasAvailableVariant) {
          input.disabled = true;
          if (label) label.style.opacity = '0.3';
        } else {
          input.disabled = false;
          if (label) label.style.opacity = '';
        }
      });
    });
  }
}

customElements.define('variant-radios', VariantRadios);
